import { Injectable } from '@angular/core';
import { FileHelperService } from '@app/services';
import { VacationYTDBalancesReportAdditionalFields } from '../interfaces/additional-report-fields.interface';
import { Report } from './queries/report';
import { ReportFilter } from '../interfaces/report-filter.interface';

@Injectable()
export class VacationYTDBalancesReportService {
    additionalReportFields: VacationYTDBalancesReportAdditionalFields = {
        endDate: null,
        startDate: null,
    };

    constructor(private fileService: FileHelperService) {}

    async fetchVacationYTDBalancesReport(
        filters: ReportFilter[] = []
    ): Promise<Report<VacationYTDBalancesReportAdditionalFields>> {
        const vacationYTDBalancesReport = await new Report<VacationYTDBalancesReportAdditionalFields>(this.fileService)
            .name('vacationYtdReport')
            .page(null)
            .withAdditionalReportFields(this.additionalReportFields)
            .filters(filters)
            .get();
        return vacationYTDBalancesReport;
    }
}
